import { apiRequest } from "../util/apiUtils";

export const countryList = async (payload) => {
  try {
    const res = await apiRequest("get", "countries", {
      queries: payload,
    });

    return res?.data;
  } catch (err) {
    return err;
  }
};
